import React, { Component } from "react";
import { connect } from 'react-redux';
import { View, ActivityIndicator, ScrollView } from "react-native";

import { ChatHeader } from "../../../components";
import ReceiveMessage from "../components/ReceiveMessage";
import SendMessage from "../components/SendMessage";
import MessageInput from "../components/MessageInput";
import * as Actions from "../../../action";
import { randomString, convertDateTime } from "../../../functions";
import { CaptionNormalDark } from "../../../components/TextStyles";
import styles from "../../../styles";
import { global, action } from "../../../const";
import { localStorage } from "../../../functions/AsyncStorage";
import { placeholder } from "../../../assets";

class ChatRoot extends Component {

    static navigationOptions = ({ navigation }) => {
        let title = navigation.getParam('name')
        return {
            title
        };
    };

    websocket = null
    websocketStatus = false;
    isConnection = 0;
    scrollPosition = 0;
    lastMegtime = null;
    isMessageLoading = false;
    messageLoaded = true;

    constructor(props) {
        super(props);
        let Id = '', HeaderTitle = "";
        const query = new URLSearchParams(props.location.search);
        Id = query.get('groupId');
        HeaderTitle = query.get('name');
        props.setGrouptarget(Id);

        this.state = {
            isLoading: true,
            userlist: false,
            searchPosition: null,
            searchStr: null,
            data: [],
            HeaderTitle,
            Id,
            userId: props.userInfo.id,
            sendMessages: [],
            before_time: 0,
            lastMessageIcon: placeholder
        }
    }

    async componentDidMount() {
        let res = await localStorage(2, "grp_cht");
        if (res) {
            let keys = Object.keys(res);
            if (keys[0] === this.state.Id) {
                this.setState({ sendMessages: JSON.parse(res[keys[0]]) })
                localStorage(3, "grp_cht")
            }
        }
        this.getMessage();
        if (window.wsConnection) {
            window.wsConnection.addEventListener("message", this.socketMessageListener);
            window.wsConnection.addEventListener("close", this.socketClosedListener);
        }
    }

    componentWillUnmount() {
        if (this.state.sendMessages.length > 0)
            localStorage(1, "grp_cht", { [this.state.Id]: JSON.stringify(this.state.sendMessages) })
        window.wsConnection.removeEventListener("message", () => null)
        window.msgListener = undefined;
        window.closedListener = undefined;

        if (window.streamReference) {
            window.streamReference.getAudioTracks().forEach((track) => {
                return track.stop();
            });
        };
    }

    socketMessageListener = (event) => {
        let data = JSON.parse(event.data);
        
        switch (data.cmd) {
            
            case "User.login":
                return this.getMessage();

            case "GroupMessage.getHistory":
                this.getMessageHistory(data.list);
                this.state.sendMessages.map(item => this.send(item))
                return setTimeout(() => this.send({ cmd: "GroupMessage.readAll1", group_id: this.state.Id }), 500);

            case "GroupMessage.send.ACK":
                if (data.target !== this.state.Id) return;
                return this.handleSendMessage(data);

            case "GroupMessage.receive":
                if (data.target === this.state.Id) {
                    let Messages = this.state.data;
                    Messages.push(data);
                    this.getMessageHistory(Messages);
                }
                return;

            default:
                return;
        }
    }

    send = (data) => {
        try {
            if (window.wsConnection) {
                if (window.wsConnection.readyState === window.wsConnection.OPEN) {
                    return window.wsConnection.send(JSON.stringify(data));
                }
            }
            window.socketMessage = this.socketMessageListener;
            window.socket(data)     // open socket connection
        } catch (error) {
            console.log(error)
            setTimeout(() => {
                window.socketMessage = this.socketMessageListener;
                window.socket(data)
            }, 20000);
        }
    }

    // socketLogin = () => {
    //     const userInfo = this.props.userInfo;
    //     this.send({ id: userInfo.id, sequence_id: userInfo.sequence_id, cmd: "WoogiChatUser.login" })
    // }

    getMessage = () => {
        this.send({
            group_id: this.state.Id,
            number: global.CHAT_MESSAGE_LOAD_LENGTH,
            before_time: this.state.before_time,
            cmd: "GroupMessage.getHistory"
        });
    }

    getMessageHistory = (Messages) => {
        try {
            let { before_time, data } = this.state;
            if (before_time === 0) {
                this.state.sendMessages.map(item => {
                    Messages.push(item);
                    this.send(item);
                })
            }

            Messages = Messages.reverse()
            if (Messages[0]) before_time = Messages[0].time;

            data = data.concat(Messages)
            let foo = new Map();
            for (const tag of data) foo.set(tag.id, tag)
            data = [...foo.values()]

            data = data.sort((a, b) => parseFloat(a.time) - parseFloat(b.time));

            this.setState({ data, isLoading: false, before_time })
            if (this.isMessageLoading) this.messageLoaded = false
            this.isMessageLoading = false;
            this.getLastReceiveMessage();
        } catch (error) {
            console.log(error)
        }
    }

    handleSendMessage = (message) => {
        try {
            let { sendMessages, data } = this.state;
            sendMessages = sendMessages.filter(item => message.client_id !== item.client_id);
            let newMsg = Object.assign({ id: message.message_id, client_id: message.client_id, target: message.target, type: message.type, message: message.message, time: message.time, sender: this.state.userId })
            let status = false
            data.map((item, i) => {
                if (item.client_id === message.client_id) {
                    data[i] = newMsg;
                    status = true;
                }
                return;
            });
            if (!status) data.push(newMsg);
            this.setState({ sendMessages, data: data });
        } catch (error) {
            console.log(error)
        }
    }

    getLastReceiveMessage = async (lastMessage) => {
        const { data } = this.state;
        const User = this.props.userInfo;
        if (!lastMessage) {
            let receiveMessage = data.filter(item => item.sender !== User.id)
            lastMessage = receiveMessage[receiveMessage.length - 1];
            lastMessage = lastMessage ? lastMessage.sender : User.id
        }

        let user = this.props.users[lastMessage]
        if (!user) {
            user = await this.props.getWcUsersInfo(lastMessage)
            user = user[0];
        }
        let image_url = global.MAKEURL(user.avatar);
        if (window.Base64Img[user.avatar])
            image_url = window.Base64Img[user.avatar]
        this.setState({ lastMessageIcon: { uri: image_url } })
    }


    renderMessage = (message, index) => {
        const User = this.props.userInfo;
        let time = null;
        const timeStamp = new Date(parseFloat(message.time) * 1000);
        if (index === 0) {
            this.lastMegtime = timeStamp;
            time = convertDateTime(timeStamp);
        }
        let diff = (timeStamp.getTime() - this.lastMegtime.getTime()) / 60000;
        if (diff > 5) time = convertDateTime(timeStamp)
        this.lastMegtime = timeStamp;

        return (
            <View key={message.id}>
                {time !== null ?
                    <View style={[styles.lableBg, styles.bglightGray]}>
                        <CaptionNormalDark title={time} />
                    </View>
                    : null}
                {
                    message.sender === User.id ?
                        <SendMessage data={message} redius={time} />
                        :
                        <ReceiveMessage data={message} user={User} />
                }
            </View>
        )
    }

    handleScroll = (width, height) => {
        if (this.messageLoaded)
            this.scrollPosition = height;
        if ((!this.state.isLoading && this.messageLoaded)) {
            this.refs.scrollView.scrollTo({ y: height, animated: false })
        }
    }

    onScroll = (e) => {
        if (e.nativeEvent.contentOffset.y <= 0 && !this.isMessageLoading) {
            this.isMessageLoading = true;
            this.getMessage();
        }
    }

    render() {
        const { data, HeaderTitle, isLoading, lastMessageIcon } = this.state;

        return (
            <View style={styles.container}>

                <ChatHeader
                    title={HeaderTitle}
                    goBack={() => this.props.history.push('/chat')}
                    lastMessageIcon={lastMessageIcon}
                />

                <ScrollView
                    scrollEnabled={true}
                    showsVerticalScrollIndicator={true}
                    ref="scrollView"
                    onContentSizeChange={this.handleScroll}
                    onScroll={this.onScroll}
                    scrollEventThrottle={15}
                    style={{ height: this.props.height - 70 - 54, marginBottom: 8}}
                >

                    {
                        isLoading ?
                            <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', marginTop: 20 }}>
                                <ActivityIndicator size="small" color="#5e23ff" />
                            </View>
                            :
                            <View style={{ marginHorizontal: 10 }}>
                                {data.map((item, i) => this.renderMessage(item, i))}
                            </View>
                    }

                </ScrollView>

                <MessageInput onsendGroupMessage={this.onsendGroupMessage} />
            </View>
        );
    }

    onsendGroupMessage = ({ type, message }) => {
        if (message === '') return false;
        let { userId, data, sendMessages, Id } = this.state;
        let client_id = randomString(32)
        let messageOjb = {
            to: Id,
            target: Id,
            type,
            id: client_id,
            sender: userId,
            message,
            client_id,
            cmd: "GroupMessage.send",
            time: (new Date()).getTime() / 1000
        }
        data.push(messageOjb);
        sendMessages.push(messageOjb)
        this.setState({ data, sendMessages })
        if (type === 2) return this.sendVoiceMessage(messageOjb);
        return this.send(messageOjb);
    }

    sendVoiceMessage = async (messageOjb) => {
        let base64 = null, duration = 0;
        if (messageOjb.message.split('^')) {
            duration = messageOjb.message.split('^')[0];
            base64 = messageOjb.message.split('^')[1]
        }
        base64 = base64.replace('data:audio/mp3;base64,', '')
        let voiceURI = await this.props.uploadVoice(base64);
        if (!voiceURI || voiceURI === null) {
            let { sendMessages, data } = this.state
            sendMessages = sendMessages.filter(item => item.client_id !== messageOjb.client_id);
            data = data.filter(item => item.client_id !== messageOjb.client_id);
            return this.setState({ sendMessages, data })
        }
        voiceURI = voiceURI + '.' + global.AUDIOFORMAT;
        messageOjb.message = duration + '^' + voiceURI
        return this.send(messageOjb);
    }

}

const mapStateToProps = ({ setting, auth, chat }) => {
    return {
        height: setting.height,
        userInfo: auth.userInfo,
        groupConversation: chat.groupConversation,
        users: auth.users,
    };
}
const mapDispatch = (dispatch) => {
    return {
        reSignIn: () => dispatch(Actions.reSignIn()),
        uploadVoice: data => Actions.uploadVoice(data),
        updateChatState: request => dispatch(Actions.updateChatState(request)),
        groupConversation: () => dispatch(Actions.groupConversation()),
        getWcUsersInfo: request => dispatch(Actions.getWcUsersInfo(request)),
        notification: request => dispatch(Actions.notifyBrowser(request)),

        setGrouptarget: (id) => dispatch({ type: action.GROUP_MESSAGES_TARGET, id }),
        sendSocketmessage: (data) => dispatch(Actions.sendSocketmessage(data)),
    }
}
export default connect(mapStateToProps, mapDispatch)(ChatRoot);